import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL',
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY'
);

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const themes = {
  light: {
    '--bg-primary': '#ded6c7',
    '--bg-secondary': '#d3c8b6',
    '--bg-tertiary': '#c9bda6',
    '--bg-card': '#e8e1d2',
    '--bg-hover': '#c3b497',
    '--text-primary': '#2c2718',
    '--text-secondary': '#5a533d',
    '--text-muted': '#857c62',
    '--border-color': '#c5b596',
    '--border-light': '#d4c6aa',
    '--accent-primary': '#68582f',
    '--accent-secondary': '#9b724b',
    '--accent-gradient': 'linear-gradient(135deg, #68582f 0%, #a07840 50%, #b9885c 100%)',
    '--accent-subtle-bg': 'rgba(104, 88, 47, 0.08)',
    '--accent-subtle-border': 'rgba(104, 88, 47, 0.22)',
    '--success': '#37725a',
    '--error': '#a63f3f',
    '--warning': '#a87424',
    '--shadow': '0 2px 8px rgba(52, 47, 33, 0.08), 0 4px 16px rgba(52, 47, 33, 0.06)',
    '--shadow-lg': '0 8px 32px rgba(52, 47, 33, 0.12), 0 16px 48px rgba(52, 47, 33, 0.08)',
    '--shadow-btn': '0 2px 8px rgba(104, 88, 47, 0.25)',
    '--glow': 'none',
  },
  dark: {
    '--bg-primary': '#171412',
    '--bg-secondary': '#1e1b17',
    '--bg-tertiary': '#272320',
    '--bg-card': '#211e1a',
    '--bg-hover': '#2e2a25',
    '--text-primary': '#e8e0d4',
    '--text-secondary': 'rgba(232, 224, 212, 0.68)',
    '--text-muted': 'rgba(232, 224, 212, 0.36)',
    '--border-color': 'rgba(232, 224, 212, 0.12)',
    '--border-light': 'rgba(232, 224, 212, 0.06)',
    '--accent-primary': '#d4a55a',
    '--accent-secondary': '#c4956e',
    '--accent-gradient': 'linear-gradient(135deg, #c49040 0%, #d4a55a 50%, #dbb876 100%)',
    '--accent-subtle-bg': 'rgba(212, 165, 90, 0.08)',
    '--accent-subtle-border': 'rgba(212, 165, 90, 0.2)',
    '--success': '#5db88a',
    '--error': '#e07070',
    '--warning': '#d4a54a',
    '--shadow': '0 2px 8px rgba(0, 0, 0, 0.2), 0 4px 16px rgba(0, 0, 0, 0.15)',
    '--shadow-lg': '0 8px 32px rgba(0, 0, 0, 0.3), 0 16px 48px rgba(0, 0, 0, 0.2)',
    '--shadow-btn': '0 2px 12px rgba(212, 165, 90, 0.2)',
    '--glow': '0 0 40px rgba(212, 165, 90, 0.06)',
  }
};

export const ARTICLE_TEMPLATES = [
  { id: 'file-matched', name: 'File-Matched', description: 'Matches your unique voice and speaking patterns', icon: '🎯' },
  { id: 'micro-story', name: 'Micro Story', description: 'Problem → Amplify → Solution format', icon: '📖' },
  { id: 'pyramid-principle', name: 'Pyramid Principle', description: 'Answer-first structure with evidence', icon: '🔺' },
  { id: 'cross-domain', name: 'Cross-Domain Synthesis', description: 'Connect ideas across disciplines', icon: '🔗' },
  { id: 'blog-it', name: 'Blog-it', description: 'Blog-ready article with clean sections', icon: '📰' }
];
